app.controller('FinalizeReviewedModalController', [
    '$scope', 'params', 'DocumentsService', 'OrganizationalUnit', 'usSpinnerService', '$uibModalInstance', '$timeout', "toastr",
    function ($scope, params, DocumentsService, OrganizationalUnit, usSpinnerService, $uibModalInstance, $timeout, toastr) {
        $scope.comment = '';
        $scope.isForStudent = params.isForStudent;
        $scope.uploadFile = function (files) {
            $timeout(function () {
                $scope.selectedFile = files[0];
                $scope.fileName = files[0].name;
            }, 0);
        };

        $scope.submit = function () {
            if ($scope.selectedFile || $scope.comment) {
                var fd = new FormData();
                $scope.disabled = true;
                fd.append('uploadedFile', $scope.selectedFile);
                params.documents.forEach(function (el) {
                    fd.append('documentIds', el._id);
                });
                fd.append('comment', $scope.comment);
                fd.append('finalIsForStudent', $scope.finalIsForStudent)
                DocumentsService.finalizeDocuments(fd).then(function (res) {
                    toastr.success('ოპერაცია წარმატებით დასრულდა');
                    $scope.disabled = false;
                    $uibModalInstance.close($scope.comment);
                });
            }
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }]);
